import { validationIsEqual } from '../status';
import { validateFile } from '@om/validation';

import { UPLOAD_PAGE_CONFIG } from '../../../actions/digiLifeLoanProtection/types';
import {
    UPLOAD_DOCUMENTS_SET_VALUE,
    setUploadDocumentsFileValid,
} from '../../../actions/kaMetlhaFuneralClaim/uploadDocuments';

export const uploadDocumentsValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;       
        switch (action.type) {
            
            case UPLOAD_DOCUMENTS_SET_VALUE:
                error = validateFile(action.value.fileContaint, {
                    minInputSize: UPLOAD_PAGE_CONFIG.MIN_INPUT_SIZE,
                    minInputSizeName: UPLOAD_PAGE_CONFIG.MIN_INPUT_SIZE_NAME,
                    maxInputSize: UPLOAD_PAGE_CONFIG.MAX_INPUT_SIZE,
                    maxInputSizeName: UPLOAD_PAGE_CONFIG.MAX_INPUT_SIZE_NAME,
                    validFileTypes: UPLOAD_PAGE_CONFIG.VALID_UPLOAD_TYPES,
                });
                return setUploadDocumentsFileValid(error, action.value.fieldType);
            default:
                return null;
        }
    })();

    if (!validationAction) {
        return next(action);
    }
    store.dispatch(validationAction);
    // prevValidationAction = validationAction;
    return next(action);
};
